module.exports = __webpack_public_path__ + "img/icon-attendance.e70d294f.png";